export default class DragToScroll {
  constructor(node) {
    console.debug('  -> DragToScroll init')

    let pos = {top: 0, left: 0, x: 0, y: 0}

    const mouseDownHandler = function (e) {
      pos = {
        // current scroll of scrollable div
        left: node.scrollLeft,
        top: node.scrollTop,

        // current mouse position
        x: e.clientX,
        y: e.clientY,
      }

      // add event listeners for grap and stop scrolling
      document.addEventListener('mousemove', mouseMoveHandler)
      document.addEventListener('mouseup', mouseUpHandler)
    }

    const mouseMoveHandler = function (e) {
      // compute mouse displacement
      const dx = e.clientX - pos.x
      const dy = e.clientY - pos.y

      // scroll update the element
      node.scrollTop = pos.top - dy
      node.scrollLeft = pos.left - dx
    }

    const mouseUpHandler = function () {
      // remove event listeners for grap and stop scrolling
      document.removeEventListener('mousemove', mouseMoveHandler)
      document.removeEventListener('mouseup', mouseUpHandler)
    }

    // add event listeners for mouse down
    document.addEventListener('mousedown', mouseDownHandler)
  }

  static init() {
    console.debug('== DragToScroll components ==')

    DragToScroll.items = Array.from(
      document.querySelectorAll('.filter-scrollable')
    ).map((node, index) => new DragToScroll(node, index))
  }
}
